import { Tabs, TabsProps } from 'antd';

import { getFromLocalStorage, writeToLocalState } from "utils/localStorage";
import { ProfileScreen } from "./components/ProfileScreen";
import { InfoMessagesCard } from "./components/InfoMessagesCard";
import { RegistrationDisabledUserScreen } from "./components/RegistrationDisabledUserScreen";
import { OrderNotFoundScreen } from "./components/OrderNotFoundScreen";
import { AppointmentAcceptScreen } from "./components/AppointmentAcceptScreen";
import { OrdersNoResultScreen } from "./components/OrdersNoResultScreen";
import { AddResultDisabledUserScreen } from "./components/AddResultDisabledUserScreen";
import { ChangeEmailScreen } from "./components/ChangeEmailScreen";
import { NewFamilyUserScreen } from "./components/NewFamilyUserScreen";
import { RegistrationSendLetterScreen } from "./components/RegistrationSendLetterScreen";
import { PasswordRecoveryScreen } from "./components/PasswordRecoveryScreen";
import { PasswordRecoverySuccessScreen } from "./components/PasswordRecoverySuccessScreen";
import { NoOrdersScreen } from "./components/NoOrdersScreen";
import { FirstViewOrdersScreen } from "./components/FirstViewOrdersScreen";
import { RegistrationInOfficeScreen } from "./components/RegistrationInOfficeScreen";
import { DynamicsScreen } from "./components/DynamicsScreen";

type TabItem = Required<TabsProps>['items'][number]

// hardcoded screenIds
const items: TabItem[] = [
  {
    key: 'profile-unauthorized',
    label: 'Профиль / Не авторизован',
    children: (
      <InfoMessagesCard
        title="Экран Профиля в неавторизованной зоне"
      >
        <ProfileScreen screenId={1} />
      </InfoMessagesCard>
    )
  },
  {
    key: 'orders-disabledUser-registration',
    label: 'Заказы / Недееспособный юзер (Регистрация)',
    children: (
      <InfoMessagesCard
        title="Попытка добавить заказ недееспособного пользователя сразу после Регистрации (точка входа: Регистрация → Я уже клиент Юнилаб → Добавление заказа)"
      >
        <RegistrationDisabledUserScreen screenId={2} />
      </InfoMessagesCard>
    )
  },
  {
    key: 'orders-notFound',
    label: 'Заказы / Не найден',
    children: (
      <InfoMessagesCard
        title="Заказ пока не найден в системе"
      >
        <OrderNotFoundScreen screenId={3} />
      </InfoMessagesCard>
    )
  },
  {
    key: 'services-appointmentAccept',
    label: 'Услуги / Запись принята',
    children: (
      <InfoMessagesCard
        title="Запись на прием принята"
      >
        <AppointmentAcceptScreen screenId={4} />
      </InfoMessagesCard>
    )
  },
  {
    key: 'orders-noResult',
    label: 'Заказы / Нет результатов',
    children: (
      <InfoMessagesCard
        title="Отсутствие результатов"
      >
        <OrdersNoResultScreen screenId={5} />
      </InfoMessagesCard>
    )
  },
  {
    key: 'orders-disabledUser',
    label: 'Заказы / Недееспособный юзер',
    children: (
      <InfoMessagesCard
        title="Добавление результата недееспособным клиентом"
      >
        <AddResultDisabledUserScreen screenId={6} />
      </InfoMessagesCard>
    )
  },
  // {
  //   key: 'profile-changeEmail',
  //   label: 'Профиль / Изменение E-mail',
  //   children: (
  //     <InfoMessagesCard
  //       title="Изменение E-mail учетной записи"
  //     >
  //       <ChangeEmailScreen screenId={7} />
  //     </InfoMessagesCard>
  //   )
  // },
  {
    key: 'profile-newFamilyUser',
    label: 'Профиль / Новый член семьи',
    children: (
      <InfoMessagesCard
        title="Добавление пользователя в разделе Моя семья"
      >
        <NewFamilyUserScreen screenId={7} />
      </InfoMessagesCard>
    )
  },
  {
    key: 'registration-sendLetter',
    label: 'Регистрация / Отправка пиьма',
    children: (
      <InfoMessagesCard
        title="Отправка письма при Регистрации"
      >
        <RegistrationSendLetterScreen screenId={8} />
      </InfoMessagesCard>
    )
  },
  {
    key: 'profile-passwordRecovery',
    label: 'Профиль / Восстановление пароля (отправка письма)',
    children: (
      <InfoMessagesCard
        title="Отправка письма при Восстановлении пароля"
      >
        <PasswordRecoveryScreen screenId={9} />
      </InfoMessagesCard>
    )
  },
  {
    key: 'passwordRecoverySuccess',
    label: 'Профиль / Пароль восстановлен',
    children: (
      <InfoMessagesCard
        title="Успешное восстановление пароля"
      >
        <PasswordRecoverySuccessScreen screenId={10} />
      </InfoMessagesCard>
    )
  },
  {
    key: 'orders-noOrders',
    label: 'Заказы / Нет заказов',
    children: (
      <InfoMessagesCard
        title="Отсутствие заказов на табе Заказы"
      >
        <NoOrdersScreen screenId={11} />
      </InfoMessagesCard>
    )
  },
  {
    key: 'orders-firstView',
    label: 'Заказы / Первый вход',
    children: (
      <InfoMessagesCard
        title="Данный экран отображается клиенту 1 раз (в первый вход на экран), при условии, если как минимум в Заказах есть 1 заказ"
      >
        <FirstViewOrdersScreen screenId={12} />
      </InfoMessagesCard>
    )
  },
  // {
  //   key: 'orders-registrationInOffice',
  //   label: 'Заказы / Запись',
  //   children: (
  //     <InfoMessagesCard
  //       title="Запись в кабинет в Заказах"
  //     >
  //       <RegistrationInOfficeScreen screenId={13} />
  //     </InfoMessagesCard>
  //   )
  // },
  {
    key: 'profile-dynamics',
    label: 'Профиль / Динамика',
    children: (
      <InfoMessagesCard
        title="Экран Динамика в том случае, если у клиента нет показателей"
      >
        <DynamicsScreen screenId={14} />
      </InfoMessagesCard>
    )
  },
];

const LOCAL_STORAGE_KEY = 'infoMessagesTab';

const InfoMessages = () => {
  const handleChangeTab = (selectedTab: string) => {
    writeToLocalState(LOCAL_STORAGE_KEY, selectedTab);
  };
  return (
    <>
      <Tabs
        defaultActiveKey={getFromLocalStorage(LOCAL_STORAGE_KEY)}
        onChange={handleChangeTab}
        items={items}
        type="line"
      />
    </>
  );
};

export default InfoMessages;
